import { TextStyle, Text, IDestroyOptions } from "pixi.js";
import { ButtonWithScaleAnimation } from "../../../../common/components/ButtonWithScaleAnimation";
import { SoundsResourcePackageWrapper } from "../../../../common/resources/SoundsResourcePackageWrapper";
import { UserProfileResourcePackage } from "../../resources/UserProfileResourcePackage";
import { GameFont } from "../../../../common/GameFont";
import { ILogger } from "by/gamefactory/cityversetycoon/logger/ILogger";

export class StoreButton extends ButtonWithScaleAnimation {
    private readonly soundResources: SoundsResourcePackageWrapper;
    private readonly logger: ILogger;

    public constructor(
        userProfileResources: UserProfileResourcePackage,
        soundResources: SoundsResourcePackageWrapper,
        logger: ILogger
    ) {
        super(userProfileResources.assets_views_user_profile_store_icon_png);
        this.soundResources = soundResources;
        this.logger = logger;
        this.onUp.add(this.clickHandle, this);
        this.build();
    }

    private build(): void {
        const storeText = new Text('STORE', new StoreTextStyle());
        storeText.position.set(13, 153);
        this.addChild(storeText);
    }

    private async clickHandle(): Promise<void> {
        this.eventMode = "auto";
        try {
            this.soundResources.assets_sounds_Choose_Card_mp3.play();
        } catch (error: unknown) {
            this.logger.error(error);
        } finally {
            this.eventMode = "static";
        }
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.onUp.remove(this.clickHandle, this);
        super.destroy(options);
    }
}

class StoreTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fill: "#ffffff",
            align: "center",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 40
        }));
    }
}